import { requestApi, downloadCsv } from "../funcitons";

export default {
    getProjects: async () => {
        const res = await requestApi('projects', 'GET');
        return res.data;
    },
    getProject: async (id) => {
        const res = await requestApi(`projects/${id}`, 'GET');
        return res.data;
    },
    createProject: async (name, description, screen_size_id) => {
        const res = await requestApi('projects', 'POST', { name, description, screen_size_id });
        return res.data;
    },
    updateProject: async (id, data) => {
        const res = await requestApi(`projects/${id}`, 'PUT', data);
        return res.data;
    },
    deleteProject: async (id) => {
        const res = await requestApi('projects/' + id, 'DELETE');
        return res.data;
    },
    exportProject: async (id) => {
        const res = await requestApi('projects/' + id + '/export', 'GET');
        return res.data;
    },

    // Stats
    getProjectStats: async (id) => {
        const res = await requestApi('trace-logs/project/' + id + '/stats', 'GET');
        return res.data;
    },
    getDeviceStats: async (id) => {
        const res = await requestApi('trace-logs/device/' + id + '/stats', 'GET');
        return res.data;
    },
    
    // Charts (données pour graphiques)
    getProjectCharts: async (id) => {
        const res = await requestApi('trace-logs/project/' + id + '/charts', 'GET');
        return res.data;
    },
    
    // Téléchargement CSV
    downloadProjectLogsCsv: async (id, projectName = 'project') => {
        const date = new Date().toISOString().split('T')[0];
        const filename = `logs_${projectName.replace(/\s+/g, '_')}_${date}.csv`;
        return await downloadCsv(`trace-logs/project/${id}/export/logs`, filename);
    },
    downloadProjectStatsCsv: async (id, projectName = 'project') => {
        const date = new Date().toISOString().split('T')[0];
        const filename = `stats_${projectName.replace(/\s+/g, '_')}_${date}.csv`;
        return await downloadCsv(`trace-logs/project/${id}/export/stats`, filename);
    },
    downloadDeviceLogsCsv: async (id, deviceName = 'device') => {
        const date = new Date().toISOString().split('T')[0];
        const filename = `logs_${deviceName.replace(/\s+/g, '_')}_${date}.csv`;
        return await downloadCsv(`trace-logs/device/${id}/export/logs`, filename);
    },
    
    // Déploiement
    getProjectAssets: async (id) => {
        const res = await requestApi(`deploy/project/${id}/assets`, 'GET');
        return res.data;
    },
    downloadProjectZip: async (id, projectName = 'project', initialPageId = null) => {
        const date = new Date().toISOString().split('T')[0];
        const filename = `${projectName.replace(/\s+/g, '_')}_deploy_${date}.zip`;
        let url = `deploy/project/${id}/zip`;
        if (initialPageId) {
            url += `?initial_page_id=${initialPageId}`;
        }
        return await downloadCsv(url, filename);
    },
    getCommandDisplayInfo: async (id) => {
        const res = await requestApi(`projects/${id}/command-display`, 'GET');
        return res.data;
    },
    regenerateCommandDisplayToken: async (id) => {
        const res = await requestApi(`projects/${id}/command-display/regenerate-token`, 'POST');
        return res.data;
    },
    getNewCactusConfig: async (id) => {
        const res = await requestApi(`newcactus/cms/projects/${id}/config`, 'GET');
        return res.data;
    },
    updateNewCactusConfig: async (id, data) => {
        const res = await requestApi(`newcactus/cms/projects/${id}/config`, 'PUT', data);
        return res.data;
    },
    testNewCactusConnection: async (id) => {
        const res = await requestApi(`newcactus/cms/projects/${id}/test`, 'POST');
        return res.data;
    },
};